import axiosFactory from "./axios.factory";

class WarehouseService {
  async getWarehouses() {
    const result = await axiosFactory().get("/warehouses");
    return result.data.data;
  }

  async getLocationsByWarehouse({ warehouseId, location, storageLocationId, isPulldown, isActive }) {
    let loc = "";
    if (location) {
      loc = location;
    }
    let locId = null;
    if (storageLocationId) {
      locId = storageLocationId;
    }
    const result = await axiosFactory().get(`/warehouses/storage_locations`, { params: { warehouseId, location, storageLocationId, isPulldown, isActive } });
    return result.data.data;
  }

  async getHistoryTypes() {
    const result = await axiosFactory().get("/warehouses/history_types");
    return result.data.data;
  }

  async getSkuStats({ keywords, warehouseId, page, pageSize }) {
    const result = await axiosFactory().get("/warehouses/sku_stats", {
      params: { keywords, warehouseId, page, pageSize },
    });
    return result.data.data;
  }
  async getInventories({ keywords, warehouseId, page, pageSize, sku, exactMatchSku, includeBWare }) {
    const result = await axiosFactory().get("/warehouses/sku_stats", {
      params: { keywords, warehouseId, sku, exactMatchSku, includeBWare, pageIndex: page, pageSize },
    });
    return result.data;
  }
  async getWarehouseInventoriesBySku(sku) {
    const result = await axiosFactory().get(`/warehouses/${sku}/details`);
    return result.data.data;
  }

  async getWarehouseHistoriesBySku(sku) {
    const result = await axiosFactory().get(`/warehouses/${sku}/histories`);
    return result.data.data;
  }

  async createStorageLocation(opts) {
    const result = await axiosFactory().post(`/warehouses/storage_locations`, opts);
    return result.data.data;
  }

  async updateStorageLocation(opts) {
    const formData = { ...opts };
    delete formData?.warehouseId;
    const result = await axiosFactory().put(`/warehouses/storage_locations/${formData.locationId}`, formData);
    return result.data.data;
  }

  // --- WMS mobil (Trello 21.08.): dieselben Endpunkte wie die Desktop-Dialoge in Warehouses.vue ---

  async getWarehouseInventories(params) {
    const result = await axiosFactory().get("/warehouses/inventories", { params });
    return result.data;
  }

  async addIncomingGoods(model) {
    const result = await axiosFactory().post("/warehouses", model);
    return result.data;
  }

  async moveGoods(model) {
    const result = await axiosFactory().post("/warehouses/moving", model);
    return result.data;
  }

  async manualAdjustment(model) {
    const result = await axiosFactory().post("/warehouses/manual_adjustment", model);
    return result.data;
  }

  async changeStorageLocationStatus(id, status) {
    const result = await axiosFactory().patch(`/warehouses/storage_locations/${id}/update_status/${status}`);
    return result.data;
  }

  // Foto-Auslesen (Vision): kind = "ean" (SKU vom Artikel-Sticker) oder "location" (Lagerplatzschild)
  async extractFromPhoto(file, kind) {
    const formData = new FormData();
    formData.append("file", file, file.name || "foto.jpg");
    const result = await axiosFactory().post("/warehouses/extract", formData, {
      params: { kind },
      headers: { "Content-Type": "multipart/form-data" },
      timeout: 180000,
    });
    return result.data.data;
  }
}

export default new WarehouseService();
